import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';
import { RoleType } from '@promo/shared';
import type { User } from '@promo/shared';

export function useGlobalBarRaisers() {
  return useQuery<User[], Error>({
    queryKey: ['users', 'global-bar-raisers'],
    queryFn: () => get<User[]>('/users', { role: RoleType.BAR_RAISER }),
    staleTime: 5 * 60 * 1000,
  });
} 